import React, { useState, useEffect } from "react";
import "./Newsletter.css";

import { FaEnvelope } from "react-icons/fa"; // Importing email icon

const SUBSCRIBE_EMAIL = "the23coffeeshop@yahoo.com";



const Newsletter = ({ idPrefix }) => {

  // State hooks for managing form values and errors
  const [email, setEmail] = useState(""); 
  const [mailSent, setMailSent] = useState(false); // To track if the email is successfully sent
  const [serverError, setServerError] = useState(""); // To store server-side errors
  const [emailLink, setEmailLink] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Using useEffect to reset the mailSent state after a few seconds
  useEffect(() => {
    const timer = mailSent && setTimeout(() => setMailSent(false), 3000);
    return () => timer && clearTimeout(timer);
  }, [mailSent]); // This effect runs when the mailSent state changes

  const buildSubscribeEmail = () => {
    const subject = "Subscribe";
    const body = [
      "Newsletter Subscription Request",
      "",
      `Email: ${email}`,
    ].join("\n");

    return `mailto:${SUBSCRIBE_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const openEmailDraft = (href) => {
    const emailWindow = window.open(href, "_blank", "noopener,noreferrer");

    if (emailWindow) {
      return;
    }

    const emailAnchor = document.createElement("a");
    emailAnchor.href = href;
    emailAnchor.target = "_blank";
    emailAnchor.rel = "noopener noreferrer";
    emailAnchor.style.display = "none";
    document.body.appendChild(emailAnchor);
    emailAnchor.click();
    document.body.removeChild(emailAnchor);
  };

  // Handle form submission
  const handleSubmit = (e) => {

    e.preventDefault(); // Prevent the default form submission
    setIsSubmitting(true);

    try {
      setServerError(""); // Clear any previous server errors

      // Basic email validation using regular expression
      if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        throw new Error("Please enter a valid email address"); // Show error if email is invalid
      }

      const subscribeEmailLink = buildSubscribeEmail();
      setEmailLink(subscribeEmailLink);
      openEmailDraft(subscribeEmailLink);
      setMailSent(true); // Set mailSent to true for success message

    } catch (error) {
      // Handle errors
      const errorMessage = error.message 
        || "An error occurred"; // Get error message
      setServerError(errorMessage); // Set server error state
    } finally {
      setIsSubmitting(false);
    }

  };

  return (
    <form
      onSubmit={handleSubmit} // Handle form submission
      className="dark-form news-form"
    >

      {/* Input field with icon for dark variant */}
      <div className="input-field">

        <label htmlFor="news-email" className="icon">
          <FaEnvelope /> {/* Envelope icon */}
        </label>
        <input type="email" id={`news-email-${idPrefix}`} value={email} onChange={(e) => setEmail(e.target.value)} className="box" placeholder="Your email address" disabled={isSubmitting} required />

      </div>
      
      {/* Submit button */}
      <button type="submit" className="btn" disabled={isSubmitting}>
        {isSubmitting ? "Processing..." : "Subscribe"}
      </button>

      {/* Display success or error message */}
      {(mailSent || serverError) && (
        <span 
          className={`alert ${mailSent ? "success" : "error"}`} // Show success or error class
          id={`msg-${idPrefix}`}
        >
          {mailSent ? "Email draft opened for subscription. If it did not open, use the link below." : serverError} {/* Display success or error message */}
          {mailSent && emailLink && (
            <a href={emailLink} className="btn" target="_blank" rel="noopener noreferrer">
              Open email draft
            </a>
          )}
        </span>
      )}
    </form>
  );
};

export default Newsletter;
